/* Current Nostalgia — key measurements inline on the product page.
   Reads the row for the viewed size from the Sizing accordion (#CnSizeGuide, built by
   snippets/cn-size-guide.liquid) and shows the two numbers resale buyers check first
   (pit to pit + length for tops, waist + inseam for bottoms) right above Add to Bag,
   in the unit the shopper picked. Renders nothing when there are no measurements. */
(function () {
  if (window.__cnMeasure) return;
  window.__cnMeasure = true;
  var LABELS = { pp: 'Pit to pit', bl: 'Length', sw: 'Shoulder', sl: 'Sleeve', wa: 'Waist', in: 'Inseam', ol: 'Outseam' };
  var TOPS = ['pp', 'bl', 'sw', 'sl'];
  var BOTTOMS = ['wa', 'in', 'ol'];

  function cell(tr, k) {
    var td = tr.querySelector('td.cn-sg__c-' + k);
    if (!td) return null;
    var g = td.closest('.cn-sg');
    if (g && g.classList.contains('cn-sg--no-' + k)) return null;
    var i = td.querySelector('.cn-sg__in'), c = td.querySelector('.cn-sg__cm');
    if (!i) return null;
    return { in: i.textContent.trim(), cm: c ? c.textContent.trim() : '' };
  }

  function render() {
    var guide = document.getElementById('CnSizeGuide');
    var pdp = document.querySelector('.cn-pdp');
    var old = pdp && pdp.querySelector('[data-cn-measure]');
    if (!guide || !pdp) { if (old) old.remove(); return; }
    var rows = guide.querySelectorAll('tbody tr');
    var tr = guide.querySelector('tbody tr.is-current') || (rows.length === 1 ? rows[0] : null);
    if (!tr) { if (old) old.remove(); return; }
    var unit = guide.getAttribute('data-unit') === 'cm' ? 'cm' : 'in';
    var keys = (cell(tr, 'wa') || cell(tr, 'in')) ? BOTTOMS : TOPS;
    var parts = [];
    keys.forEach(function (k) {
      if (parts.length >= 2) return;
      var c = cell(tr, k);
      if (!c || !c.in) return;
      var v = unit === 'cm' ? (c.cm + ' cm') : (c.in + '″');
      parts.push('<span class="cn-measure__i"><span class="cn-measure__k">' + LABELS[k] + '</span> <b>' + v + '</b></span>');
    });
    if (!parts.length) { if (old) old.remove(); return; }
    var html = parts.join('') + '<button type="button" class="cn-measure__all" data-cn-measure-all>All measurements</button>';
    /* Compare against what was last written, not innerHTML: the browser rewrites the bare
       data-cn-measure-all attribute as data-cn-measure-all="", so innerHTML never matched, the
       line was rebuilt on every DOM change, the rebuild was itself a DOM change - and the button
       was swapped out every 30ms, mid-click, which is why "All measurements" never responded. */
    if (old) { if (old.__cnHtml !== html) { old.innerHTML = html; old.__cnHtml = html; } return; }
    var form = pdp.querySelector('.cn-pdp__form');
    if (!form) return;
    var el = document.createElement('p');
    el.className = 'cn-measure';
    el.setAttribute('data-cn-measure', '');
    el.innerHTML = html;
    el.__cnHtml = html;
    form.parentNode.insertBefore(el, form);
  }

  /* "All measurements" (v64). It used to open the Sizing accordion and scroll to it - but the
     accordion is already open, and on desktop it sits in the sticky left column, so scrolling
     the page doesn't move it into view and the button looked dead. It now opens the full chart
     (with the diagram and how-to-measure notes) in a dialog right where the shopper is. The
     dialog shows a copy of the Sizing panel and keeps the inches / cm choice in step with it. */
  var dlg = null;
  function openAll() {
    var g = document.getElementById('CnSizeGuide');
    if (!g) return;
    var body = g.querySelector('.cn-sg__body');
    if (!body) { g.open = true; g.scrollIntoView({ behavior: 'smooth', block: 'start' }); return; }
    if (!dlg) {
      dlg = document.createElement('dialog');
      dlg.className = 'cn-mdlg';
      dlg.setAttribute('aria-label', 'All measurements');
      dlg.addEventListener('click', function (e) {
        if (e.target === dlg || e.target.closest('[data-cn-mdlg-close]')) dlg.close();
        var u = e.target.closest('[data-cn-sg-unit]');
        if (u) setTimeout(syncUnit, 0);
      });
      document.body.appendChild(dlg);
    }
    var wrap = document.createElement('div');
    wrap.className = g.className.replace('cn-acc__item', '').trim() + ' cn-mdlg__sg';
    wrap.setAttribute('data-cn-mdlg-sg', '');
    var copy = body.cloneNode(true);
    copy.classList.remove('cn-acc__body');
    copy.querySelectorAll('[id]').forEach(function (el) { if (el.tagName.toLowerCase() !== 'marker') el.removeAttribute('id'); });
    wrap.appendChild(copy);
    dlg.innerHTML = '<div class="cn-mdlg__head"><p class="cn-mdlg__title">All measurements</p>' +
      '<button type="button" class="cn-mdlg__x" data-cn-mdlg-close aria-label="Close">' +
      '<svg width="14" height="14" viewBox="0 0 14 14" aria-hidden="true"><path d="M1 1l12 12M13 1L1 13" stroke="currentColor" stroke-width="1.5"/></svg></button></div>';
    dlg.appendChild(wrap);
    syncUnit();
    if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', '');
  }
  function syncUnit() {
    var g = document.getElementById('CnSizeGuide');
    var w = dlg && dlg.querySelector('[data-cn-mdlg-sg]');
    if (!g || !w) return;
    var u = g.getAttribute('data-unit') || 'in';
    w.setAttribute('data-unit', u);
    w.querySelectorAll('[data-cn-sg-unit]').forEach(function (b) {
      b.setAttribute('aria-pressed', b.getAttribute('data-cn-sg-unit') === u ? 'true' : 'false');
    });
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cn-measure-all]')) { openAll(); return; }
    if (e.target.closest('[data-cn-sg-unit]')) setTimeout(render, 0);
  });
  var t;
  if (window.MutationObserver) {
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(render, 30); })
      .observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', render); else render();
})();

/* v73 - phones: a slim pinned "Add to bag" bar. The full buy box now sits in the page under the
   title, so it no longer covers the photo; once its real button scrolls out of view, this bar
   (name, price, Add to bag) slides up from the bottom. Its button presses the real one, so the
   size picked, sold-out state and cart drawer all behave exactly as before.
   v94: the price moves onto the button ("Add to Bag · $98.00"); under the name sits
   "100% authentic". A sold-out piece shows just "Sold Out". */
(function () {
  if (window.__cnBuybar) return;
  window.__cnBuybar = true;
  function init() {
    var box = document.querySelector('.shopify-section > .cn-pdp .cn-pdp__buybox');
    if (!box || !('IntersectionObserver' in window)) return;
    var real = box.querySelector('.cn-pdp__form button[name="add"]');
    if (!real) return;
    var titleEl = document.querySelector('.shopify-section > .cn-pdp .cn-pdp__title');
    var priceEl = document.querySelector('.shopify-section > .cn-pdp [data-cn-price]');
    var bar = document.createElement('div');
    bar.className = 'cn-buybar';
    bar.setAttribute('aria-hidden', 'true');
    bar.innerHTML = '<span class="cn-buybar__text"><span class="cn-buybar__name"></span><span class="cn-buybar__auth"><svg width="11" height="11" viewBox="0 0 14 14" aria-hidden="true"><path d="M2 7.5l3 3 7-7" fill="none" stroke="currentColor" stroke-width="1.8"/></svg>100% authentic</span></span><button type="button" class="cn-buybar__btn" tabindex="-1"><span class="cn-buybar__label"></span><span class="cn-buybar__price"></span></button>';
    var name = bar.querySelector('.cn-buybar__name');
    var price = bar.querySelector('.cn-buybar__price');
    var btn = bar.querySelector('.cn-buybar__btn');
    var btnLabel = bar.querySelector('.cn-buybar__label');
    function sync() {
      name.textContent = titleEl ? titleEl.textContent.trim() : document.title;
      var label = real.querySelector('[data-cn-btn-label]');
      btnLabel.textContent = (label ? label.textContent : real.textContent).trim() || 'Add to bag';
      btn.disabled = real.disabled || real.getAttribute('aria-disabled') === 'true';
      /* the current price only - a sale's struck-through price stays on the page */
      var now = priceEl && (priceEl.querySelector('span:last-child') || priceEl);
      price.textContent = !btn.disabled && now ? now.textContent.replace(/\s+/g, ' ').trim() : '';
    }
    sync();
    document.body.appendChild(bar);
    btn.addEventListener('click', function () { if (!real.disabled) real.click(); });
    new MutationObserver(sync).observe(real, { attributes: true, childList: true, subtree: true, characterData: true });
    if (priceEl) new MutationObserver(sync).observe(priceEl, { childList: true, subtree: true, characterData: true });
    var narrow = window.matchMedia('(max-width: 989px)');
    new IntersectionObserver(function (entries) {
      var e = entries[0];
      /* only once the real button is above the screen (scrolled past), not before reaching it */
      var past = !e.isIntersecting && e.boundingClientRect.top < 0;
      bar.classList.toggle('is-on', past && narrow.matches);
      bar.setAttribute('aria-hidden', past ? 'false' : 'true');
      btn.tabIndex = past ? 0 : -1;
    }).observe(real);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();